import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Button } from 'ui-components/components/button';
import LocalePicker from '../locale-picker';
import messages from './messages';

import style from './verify-email-form.module.css';

const VerifyForm = ({ userToken, emailChangeToken = '', onVerifyClick }) => {
  const [error, setError] = useState('');

  const onVerifyError = useCallback(() => {
    setError(messages.verifyErrorMessage);
  }, []);

  const onVerifyClicked = useCallback(() => {
    onVerifyClick(userToken, emailChangeToken, onVerifyError);
  }, [onVerifyClick, onVerifyError, userToken, emailChangeToken]);

  useEffect(() => {
    if (userToken) {
      onVerifyClicked(userToken);
    }
  }, [onVerifyClicked, userToken]);

  return (
    <div className={style['verify-form']}>
      <div className={style['verify-form-title']}>
        <FormattedMessage {...messages.verifyEmail} />
      </div>
      {error ? (
        <div className={style['error-message']}>
          <FormattedMessage {...error} />
        </div>
      ) : (
        <div>
          <LoadingIndicator className={style['loading-icon']} theme='white' />
          <div className={style['one-moment-please']}>
            <FormattedMessage {...messages.oneMoment} />
            ...
          </div>
        </div>
      )}
      <footer>
        <Button className={style['resend-email']} href='/resend-verification' theme='link'>
          <FormattedMessage {...messages.resendEmail} />
        </Button>
        <LocalePicker />
      </footer>
    </div>
  );
};

VerifyForm.propTypes = {
  userToken: PropTypes.string.isRequired,
  emailChangeToken: PropTypes.string,
  onVerifyClick: PropTypes.func.isRequired,
};

export default VerifyForm;
